import type { LoginStep } from "@custos/api-client";
import { create } from "zustand";

/** The pending 2FA step after a correct password. Memory only — never stored in the browser. */
export interface Challenge {
  token: string;
  status: LoginStep["status"];
  email: string | null;
}

interface AuthState {
  status: "loading" | "anonymous" | "authenticated";
  challenge: Challenge | null;
  /** One-off message for the login screen, e.g. after the session expired. */
  notice: string | null;
  setAuthenticated: () => void;
  setAnonymous: () => void;
  sessionExpired: () => void;
  setChallenge: (challenge: Challenge | null) => void;
  setNotice: (notice: string | null) => void;
}

export const useAuth = create<AuthState>((set) => ({
  status: "loading",
  challenge: null,
  notice: null,
  setAuthenticated: () => set({ status: "authenticated", challenge: null, notice: null }),
  setAnonymous: () => set({ status: "anonymous" }),
  sessionExpired: () =>
    set({
      status: "anonymous",
      notice: "Your session ended (expired or logged out from another device). Please log in again.",
    }),
  setChallenge: (challenge) => set({ challenge }),
  setNotice: (notice) => set({ notice }),
}));
